import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

/** Root notification channel, including existing callers that inject MessageService. */
@Injectable({ providedIn: 'root' })
export class NotificationService extends MessageService {
  private readonly translate = inject(TranslateService);

  override add(message: ToastMessageOptions): void {
    const summaryKey = {
      success: 'SUCCESS',
      error: 'ERROR',
      warn: 'UI_NOTIFICATIONS.WARNING',
      info: 'UI_NOTIFICATIONS.INFORMATION'
    }[message.severity];
    super.add({
      life: message.severity === 'success' ? 4000 : 8000,
      ...(summaryKey ? { summary: this.translate.instant(summaryKey) } : {}),
      ...message
    });
  }

  override addAll(messages: ToastMessageOptions[]): void {
    for (const message of messages) this.add(message);
  }

  success(detailKey: string): void {
    this.notify('success', detailKey);
  }

  error(detailKey: string): void {
    this.notify('error', detailKey);
  }

  warn(detailKey: string): void {
    this.notify('warn', detailKey);
  }

  info(detailKey: string): void {
    this.notify('info', detailKey);
  }

  private notify(severity: string, detailKey: string): void {
    this.add({ severity, detail: this.translate.instant(detailKey) });
  }
}
